import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Wedding & Event Photographer in Lucknow | Frames by Gaurav',
  description = 'Wedding and event photography in Lucknow by Frames by Gaurav. Explore our work, packages and availability for your celebration.',
  ogImage = 'https://images.pexels.com/photos/37380248/pexels-photo-37380248.jpeg?auto=compress&cs=tinysrgb&w=1200&h=630&fit=crop',
  ogType = 'website',
  canonicalUrl,
  structuredData,
}) => {
  const siteUrl = 'https://www.framesbygaurav.com';
  const fullUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Frames by Gaurav photography" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
